import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../html/element'
import classes from './index.module.scss'

export const ButtonBack = ({ text, onClick, style }) => {
  return (
    <Element
      style={{ border: '1px solid #d5d5d5', ...style }}
      className={classes.iconBack}
      onClick={onClick}
    >
      <Element
        elementName="i"
        className="icon-arrow-left"
        style={{ fontSize: 8, color: '#3a414b' }}
      />
      <Element elementName="p">
        <Translate value={text || ''} />
      </Element>
    </Element>
  )
}

ButtonBack.propTypes = {
  text: PropTypes.string,
  linkTo: PropTypes.string,
  style: PropTypes.object,
}

ButtonBack.defaultProps = {
  style: {},
}
